import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { ApiIntegrationsService } from '@app/_shared/service/http/api-integrations.service';
import { SnackBarService } from '@app/_shared/snack-bars/snack-bar.service';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import * as IntegrationsActions from './integrations.actions';
import {
  createIntegrationFailed,
  createIntegrationSuccess,
  deleteIntegrationFailed,
  deleteIntegrationSuccess,
  loadIntegrationsFailure,
  loadIntegrationsSuccess,
  updateIntegrationFailed,
  updateIntegrationSuccess,
} from './integrations.actions';

@Injectable()
export class IntegrationsEffects {
  private actions$ = inject(Actions);
  private apiIntegrationService = inject(ApiIntegrationsService);
  private snackBarService = inject(SnackBarService);

  loadIntegrations$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(IntegrationsActions.loadIntegrations),
      switchMap((data) => {
        return this.apiIntegrationService.index(data.storeId, data.category).pipe(
          map((response) => {
            return loadIntegrationsSuccess(response);
          }),
          catchError((error) => of(loadIntegrationsFailure(error.error))),
        );
      }),
    );
  });

  createIntegration$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(IntegrationsActions.createIntegration),
      switchMap((data) => {
        return this.apiIntegrationService.store(data.data).pipe(
          map((response) => {
            return createIntegrationSuccess({ data: response.data });
          }),
          catchError((error) => of(createIntegrationFailed(error.error))),
        );
      }),
    );
  });

  updateIntegration$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(IntegrationsActions.updateIntegration),
      switchMap((data) => {
        return this.apiIntegrationService.patch(+data.id, data.data).pipe(
          map((response) => {
            return updateIntegrationSuccess({ data: response.data });
          }),
          catchError((error) => of(updateIntegrationFailed(error.error))),
        );
      }),
    );
  });

  deleteIntegration$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(IntegrationsActions.deleteIntegration),
      switchMap((action) => {
        return this.apiIntegrationService.delete(action.id).pipe(
          map(() => deleteIntegrationSuccess({ id: action.id })),
          catchError((error) => of(deleteIntegrationFailed(error.error))),
        );
      }),
    );
  });

  deleteIntegrationFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteIntegrationFailed),
        tap((error) => {
          this.snackBarService.openFailure({
            header: 'Integrationen kunne ikke slettes',
            body: error.message,
          });
        }),
      ),
    { dispatch: false },
  );
}
